import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1de901c8&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\gift-of-choice\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de901c8')) {
      api.createRecord('1de901c8', component.options)
    } else {
      api.reload('1de901c8', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=1de901c8&", function () {
      api.rerender('1de901c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "GiftOfChoice/App.vue"
export default component.exports